import "bootstrap/dist/css/bootstrap.min.css";
import BaseModal from "../../BaseModal";

function SeguimientoCarrera() {
  return (
    <div>
      <BaseModal modalType="ComingSoon"></BaseModal>
    </div>
  );
}

export default SeguimientoCarrera;
